import { Observable } from 'rxjs';
import { ObtenerUrlPagoResponse } from 'src/app/global/interfaces/obtener-url-pago-response';
import { ConfiguracionProducto } from '../interfaces/configuracion-producto';
import { GeneralResponse } from '../interfaces/general-response';
import { SeleccionProductoRequest } from '../interfaces/seleccion-producto.request';
import { SeleccionProductoResponse } from '../interfaces/seleccion-producto.response';

export abstract class ProductosService {

  abstract registraSeleccionProducto(productos: SeleccionProductoRequest[]): Observable<any>;

  abstract validaPagoProducto(producto: any): Observable<any>;

  abstract obtenerUrlPago(data: any): Observable<ObtenerUrlPagoResponse>;

  abstract obtenerSeleccionProductos(): Observable<SeleccionProductoResponse>;

  abstract postConfiguracionProducto(data: any): Observable<any>;

  abstract obtenerConfiguracionProducto(): Observable<ConfiguracionProducto>;

  abstract obtenerResumenPago(): Observable<any>;

  abstract validaPagoProductoEjecutivo(run: number): Observable<GeneralResponse<any>>;
  
  abstract obtenerValorUF(): Observable<any>;

  abstract obtenerValoresMCC(): Observable<any>;

  abstract validarDescuento(descuento: String): Observable<any>;

}
